
































































































import {
  Vue, Prop, Component,
} from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import DateFormat from '@/shared/utils/date-format';
import { BillingStatusItemType } from '@/shared/utils/billing-status-item-type.enum';
import { BillingType } from '@/shared/utils/billing-type.enum';
import DownloadFileBlob from '@/shared/utils/download-file-blob';
import toDocument from '@/shared/directive/toDocument';
import ContractItem from '@/domain/contract/entity/contract-item.entity';
import CalculationService from '@/domain/calculation/service/calculation.service';
import TaskService from '@/domain/task/task.service';
import Task from '@/domain/task/task.entity';
import PerformBillingModalFields from './perform-billing-modal-fields.component.vue';
import BillingItem from './billing-item.entity';
import BillingItemsExpansion from './billing-items-expansion.component.vue';

@Component({
  components: {
    PerformBillingModalFields,
    BillingItemsExpansion,
  },
})
export default class PerformBillingAllItemsModal extends Vue {
  @Prop({ required: true }) showModal!: boolean;

  @Prop({ required: true }) businessUnitId!: string;

  @Prop({ required: true }) items!: Array<ContractItem>;

  @Prop({ required: true }) billingEmails!: string;

  @Prop({ required: true }) customer!: string;

  @Prop({ required: true }) document!: string;

  @Prop({ required: true }) contractNumber!: string;

  competences: string[] = [];

  invoiceCompetence: string = '';

  loading: boolean = false;

  executionType: string = BillingType.SINGLE;

  startDate: string = '';

  endDate: string = '';

  itemsToExecute: any[] = [];

  disabledSendEmail: boolean = true;

  loadingEmail: boolean = false;

  loadingDownload: boolean = false;

  created() {
    this.itemsToExecute = this.items
      .filter((item) => item.frequency?.value === 'MONTHLY')
      .map((item) => {
        if (!item.hasCustomMacros) item.observation = '';
        return new BillingItem(item);
      });
  }

  get isSingle() {
    return this.executionType === BillingType.SINGLE;
  }

  get modalState() {
    return this.showModal;
  }

  set modalState(value: boolean) {
    this.itemsToExecute = [];
    this.disabledSendEmail = true;
    this.$emit('updateModalState', value);
  }

  startLoading(): void {
    this.loading = true;
  }

  stopLoading(): void {
    this.loading = false;
  }

  closeDialog(): void {
    this.itemsToExecute = [];
    this.disabledSendEmail = true;
    this.modalState = false;
  }

  handleSimulationExecution() {
    this.disabledSendEmail = true;
    const { form }: any = this.$refs;
    if (!form.validate()) return;

    this.startLoading();
    if (this.isSingle) {
      this.simulateBilling();
    } else {
      this.simulateRetroactiveBilling();
    }

    setTimeout(() => {
      this.stopLoading();
    }, 2 * 1000);
  }

  setStatusSendEmail() {
    this.disabledSendEmail = this.itemsToExecute.length > 0
      ? this.itemsToExecute.findIndex((it) => it.status !== BillingStatusItemType.VALID) > -1
      : true;
  }

  sendEmail(): void {
    this.loadingEmail = true;
    CalculationService.sendSimulationEmail(this.prepareParams())
      .then(() => VbSnackbarService.showSuccess('E-mail enviado com sucesso'))
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => this.loadingEmail = false);
  }

  getItens() {
    return this.itemsToExecute.map((item) => ({
      itemId: item.id,
      itemDescription: item.description,
      taskId: item.taskId,
    }));
  }

  prepareParams() {
    const items = this.getItens();
    return {
      competences: this.competences,
      invoiceCompetence: this.invoiceCompetence ? DateFormat.monthNumberYear(this.invoiceCompetence) : '',
      startDate: this.startDate ? DateFormat.monthNumberYear(this.startDate) : '',
      endDate: this.endDate ? DateFormat.monthNumberYear(this.endDate) : '',
      items,
      customer: this.customer.replace(/[^a-zA-Z0-9\s.-]/g, ' '),
      document: toDocument(this.document),
      contractNumber: this.contractNumber,
      emails: this.billingEmails,
    };
  }

  downloadPDF() {
    this.loadingDownload = true;
    CalculationService.downloadFileSimulationBase64(this.prepareParams(), 'PDF')
      .then((downloadData) => {
        DownloadFileBlob.download('simulacao.pdf', `data:application/pdf;base64,${downloadData}`);
      })
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => this.loadingDownload = false);
  }

  downloadDoc() {
    this.loadingDownload = true;
    CalculationService.downloadFileSimulationBase64(this.prepareParams(), 'DOC')
      .then((downloadData) => {
        DownloadFileBlob.download('simulacao.doc', `data:application/vnd.ms-word;base64,${downloadData}`);
      })
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => this.loadingDownload = false);
  }

  // Methods to simulate billing
  simulateBilling(): void {
    this.itemsToExecute.forEach((item) => {
      CalculationService
        .simulate(this.businessUnitId, item.id, this.invoiceCompetence)
        .then((taskId: string) => {
          this.handleSimulationSuccess(taskId, item.id);
        });
    });
  }

  simulateRetroactiveBilling(): void {
    this.fillRetroactiveDates();
    this.itemsToExecute.forEach((item) => {
      CalculationService
        .simulateRetroactive(
          this.businessUnitId,
          item.id,
          this.competences.join(','),
          this.invoiceCompetence,
          this.startDate,
          this.endDate,
        )
        .then((taskId: string) => this.handleSimulationSuccess(taskId, item.id))
    });
  }

  fillRetroactiveDates(): void{
    if (this.startDate === '') {
      this.startDate = this.competences[0];
    }

    if (this.endDate === '') {
      this.endDate = this.competences[this.competences.length - 1];
    }
  }

  private handleSimulationSuccess(taskId: string, itemId: string): void {
    // set loading status
    this.itemsToExecute = this.itemsToExecute.map((item) => {
      if (item.id === itemId) {
        item.taskId = taskId;
        item.status = BillingStatusItemType.LOADING;
      }
      return item;
    });

    TaskService.getTask(taskId, 2000)
      .then((task: Task) => {
        this.updateItemTask(
          taskId,
          BillingStatusItemType.VALID,
          task.payload.summary,
          task.payload.result,
          task.payload.observation,
        );
      })
      .catch((err) => {
        this.updateItemTask(taskId, BillingStatusItemType.INVALID, err.messages, 0, '');
      })
  }

  private updateItemTask(
    taskId: string,
    status: string,
    logError: string[],
    value: number,
    observation: string,
  ): void {
    this.itemsToExecute = this.itemsToExecute.map((item) => {
      if (item.taskId === taskId) {
        if (status === BillingStatusItemType.VALID) {
          item.value = value;
        }
        item.log = logError;
        item.status = status;
        item.observation = observation;
      }
      return item;
    });
    this.setStatusSendEmail();
  }

  // Methods to update fields
  updateExecutionType(executionType: string): void {
    this.executionType = executionType;
  }

  updateCompetences(competences: string[]): void {
    this.competences = competences;
  }

  updateStartDate(startDate: string): void {
    this.startDate = startDate;
  }

  updateEndDate(endDate: string): void {
    this.endDate = endDate;
  }

  updateInvoiceCompetence(invoiceCompetence: string): void {
    this.invoiceCompetence = invoiceCompetence;
  }
}
